import React from 'react';

class Loading extends React.Component {

	render() {

		return <section className="loading">
			<div className="loader">
				<div>
					<span></span>
					<span></span>
				</div>
			</div>
			<h4>{this.props.text || 'Loading' }</h4>
		</section>;
	}
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/loading.js